<template>

  <div v-if="isAppReady">
    <div  class="ra_wc_chatbox"  :class="[instance.bubblePosition === 'right' ? 'right' : 'left']" v-if="state.showPopUp && instance.widget_style=='lagacy'">
      <!-- Full Header Section -->

      <div class="ra_wc-p-5 ra_wc-rounded-t-lg"
        :style="{ backgroundColor: instance.bubbleColor }">
        <div class="ra_wc-flex ra_wc-items-center ra_wc-space-x-3">
          <!-- Avatar -->
          <div v-if="instance.logo_avatar"
            class="ra_wc-w-10 ra_wc-h-10 ra_wc-flex ra_wc-items-center ra_wc-justify-center ra_wc-bg-white ra_wc-text-gray-400 ra_wc-rounded-full">
            <img :src="instance.logo_avatar" class="ra_wc-w-full ra_wc-h-full ra_wc-object-cover ra_wc-rounded-full" />

          </div>
          <!-- Welcome Message -->
          <div>
            <h1 class="ra_wc-text-lg ra_wc-font-semibold ra_wc_text-white" style="margin: 0px;">{{
              instance.welcome_message }}</h1>
            <p class="ra_wc-text-sm ra_wc_text-white" style="margin: 0px;padding-top: 5px;">{{
              instance.welcome_tagline }}</p>
          </div>

          <div>
            <span class="ra_wc_sound_toggle" style="margin-left:100px">

              <svg v-if="state.stopMessageSound" @click="handleSound(false)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-volume-mute-fill ra_wc_text-white" viewBox="0 0 16 16">
                    <path fill="currentColor" d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06m7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0"/>
              </svg>

              <svg v-else @click="handleSound(true)"  xmlns="http://www.w3.org/2000/svg" width="16" height="16"   class="bi bi-volume-up-fill ra_wc_text-white" viewBox="0 0 16 16">
                <path fill="currentColor" d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"/>
                <path fill="currentColor" d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"/>
                <path fill="currentColor" d="M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06"/>
              </svg>

                  


              <!-- <span class="ra_wc_minimize" @click="state.showPopUp = false" title="Minimize">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"  class="bi bi-dash-lg ra_wc_text-white" viewBox="0 0 16 16">
                <path fill="currentColor" fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8"/>
              </svg>
              </span> -->

              </span> 
          </div>

        </div>
      </div>



      <div class="ra_wc_chat_wrapper"  v-if="state.chatStage !== 'start_conversation'" @scroll="handleScroll" ref="chatBox">
        <div class="ra_wc_spinner-container" v-if="state.scrollLoading" style="margin:auto;display:block">
          <div class="ra_wc_spinner"></div>
        </div>
        <div v-for="(msg, index) in sortedMessages" :key="index" class="ra_wc_message_group">
        <div :class="['ra_wc_message', msg.direction === 'in' ? 'ra_wc_user ra_wc_bg ra_wc_text-white' : 'ra_wc_bot']">

          <div v-if="msg.message_type == 'text'">
            <p v-html="msg.message"></p>
          </div>

          <div v-else-if="msg.message_type == 'image'" class="ra_wc_message_image_thumb">
            <a :href="msg.file_path" target="_blank">
              <img :src="msg.thumbnail">
            </a>
            <p v-if="msg.message != ''" style="margin-top: 3px;">{{ msg.message }}</p>
          </div>

          <div v-else-if="msg.message_type == 'image_url'" class="ra_wc_message_image_thumb">
              <a :href="msg.file_path" target="_blank">
                <img :src="msg.file_path">
              </a>
              <p v-if="msg.message != ''" style="margin-top: 3px;">{{ msg.message }}</p>
          </div>


          <div v-else-if="msg.message_type == 'document'">
            <a :href="msg.file_path" target="_blank">{{ msg.file_name }}</a>
            <p v-if="msg.message != ''" style="margin-top: 3px;">{{ msg.message }}</p>
          </div>

          <div v-else-if="msg.message_type == 'audio'">
            <audio controls class="ra_wc_small-audio-player">
              <source :src="msg.file_path" :type="msg.file_type">
              Your browser does not support the audio element.
            </audio>
            <p v-if="msg.message != ''" style="margin-top: 3px;">{{ msg.message }}</p>
          </div>

          <div v-else-if="msg.message_type == 'video'">
            <video width="150" height="150" controls>
              <source :src="msg.file_path" :type="msg.file_type">
              Your browser does not support the video tag.
            </video>
            <p v-if="msg.message != ''" style="margin-top: 3px;">{{ msg.message }}</p>
          </div>

          <div v-else-if="msg.message_type == 'other'">
            <a :href="msg.file_path" target="_blank">{{ msg.file_name }}</a>
            <p v-if="msg.message != ''" style="margin-top: 3px;">{{ msg.message }}</p>
          </div>

        </div>

       
        <div :class="[ msg.direction === 'in' ? 'ra_wc_timestamp_user' : 'ra_wc_timestamp']"  v-if="msg.updatedAt">
          <span v-if="msg.direction == 'out' && msg.sender && msg.sender!='boot'" > {{msg.sender}} &nbsp;&nbsp;</span>  {{ formatTime(msg.updatedAt) }}
        </div>

        </div>

        <div class="ra_wc_message ra_wc_bot"   v-if="state.is_typeing">
          <div class="ra_wc_chat-typing">
              <span class="ra_wc_dot"></span>
              <span class="ra_wc_dot"></span>
              <span class="ra_wc_dot"></span>
            </div>
        </div>


        
      </div>


      <div class="ra_wc_wel_chat-widget" v-if="state.chatStage === 'start_conversation'">
        <div class="ra_wc_wel_chat-content">
          <h4 v-if="instance.welcome_launcher_title != ''">{{ instance.welcome_launcher_title }}</h4>
          <p v-if="instance.launcher_reply_time != ''">{{ instance.launcher_reply_time }}</p>
          <a href="javascript:void(0);" @click="actions.startCoversation"> <span
              v-if="instance.launcher_reply_time != ''">{{ instance.launcher_link_text }}</span> <span v-else>Start
              Conversation</span> →</a>
        </div>
        <div v-if="instance.lanucher_avatar != ''"><img class="ra_wc_wel_chat-avatar" :src="instance.lanucher_avatar" />
        </div>
        <div v-if="state.infoError" class="ra_wc_error-message">
          <strong>{{ state.infoError }}</strong>
        </div>
      </div>

      <div class="ra_wc_wel_chat-widget" v-if="state.chatStage === 'info_gather'"
        style="background-color: white;">

        <div v-if="instance.prechat_name == '1' && state.infoAtive == 'name'" class="ra_wc_width">
          <label class="ra_wc_info-label">{{ instance.prechat_name_label }}</label>
          <div class="ra_wc_info-input-wrapper">
            <input @input="state.infoError = ''" @keyup.enter="actions.validateInfo('name')" type="text"
              class="ra_wc_info-input" v-model="state.userName" :placeholder="instance.prechat_name_placeholder">
            <button :style="{ backgroundColor: instance.bubbleColor }" @click.prevent="actions.validateInfo('name')"
              class="ra_wc_info-button">&gt;</button>
          </div>
        </div>

        <div v-if="instance.prechat_email && state.infoAtive == 'email'" class="ra_wc_width">
          <label class="ra_wc_info-label">
            {{ instance.prechat_email_label == '' ? "Please enter email" : instance.prechat_email_label }}
          </label>
          <div class="ra_wc_info-input-wrapper">
            <input @input="state.infoError = ''" @keyup.enter="actions.validateInfo('email')"
              :placeholder="instance.prechat_email_placeholder" v-model="state.userEmail" type="email"
              class="ra_wc_info-input">
            <button @click.prevent="actions.validateInfo('email')" :style="{ backgroundColor: instance.bubbleColor }"
              class="ra_wc_info-button">&gt;</button>
          </div>
          <div v-if="state.infoError" class="ra_wc_error-message">
            <strong>{{ state.infoError }}</strong>
          </div>
        </div>

        <div v-if="instance.prechat_whatsapp == '1' && state.infoAtive == 'whatsapp'" class="ra_wc_width">
          <label class="ra_wc_info-label">{{ instance.prechat_whatsapp_label }}</label>
          <div class="ra_wc_info-input-wrapperP">
            <input ref="whatsappInput"  @input="state.infoError = ''" @keyup.enter="actions.validateInfo('whatsapp')"
               v-model="state.userWhatsapp" type="text"
              class="ra_wc_info-input">
            <button :style="{ backgroundColor: instance.bubbleColor }" @click.prevent="actions.validateInfo('whatsapp')"
              class="ra_wc_info-button">&gt;</button>
          </div>
          <div v-if="state.infoError" class="ra_wc_error-message">
            <strong>{{ state.infoError }}</strong>
          </div>
        </div>

        <div v-if="instance.prechat_phone == '1' && state.infoAtive == 'phone'" class="ra_wc_width">
          <label class="ra_wc_info-label">{{ instance.prechat_phone_label }}</label>
          <div class="ra_wc_info-input-wrapperP">
            <input ref="phoneInput" @input="state.infoError = ''" @keyup.enter="actions.validateInfo('phone')" v-model="state.userPhone"
              type="text"  class="ra_wc_info-input">
            <button :style="{ backgroundColor: instance.bubbleColor }" @click.prevent="actions.validateInfo('phone')"
              class="ra_wc_info-button">&gt;</button>
          </div>
          <div v-if="state.infoError" class="ra_wc_error-message">
            <strong>{{ state.infoError }}</strong>
          </div>
        </div>
      </div>

      <div v-if="state.emojiPickerVisible" ref="emojiPicker"  @click.stop  class="ra_wc_emoji-popup">
        <EmojiPicker @select="addEmoji"  :disable-skin-tones="true" />
      </div>

      <div class="ra_wc_message_box" v-if="state.chatStage === 'send_message'" :style="{ minHeight: state.uploadedFiles.length ? '80px' : '34px' }"
        @dragover.prevent="actions.handleDrop" @drop="actions.handleDrop" @paste="actions.handlePaste">

        <!-- Emoji Picker (Positioned Above Message Box) -->


        <!-- File Preview -->
        <div class="ra-wc-image-preview" v-if="state.uploadedFiles.length">
          <div v-for="(file, index) in state.uploadedFiles" :key="index" class="ra-wc-file-preview">
            <img v-if="file.type.startsWith('image/')" :src="file.preview" class="ra-wc-preview-img" />
            <span v-else class="ra-wc-file-name"><small>{{ actions.getShortFileName(file.name) }}</small></span>
            <button v-if="!state.isSending" class="ra-wc-remove-preview" @click="actions.removeFile(index)">✖</button>
          </div>
        </div>

        <!-- Text Input -->
        <textarea ref="messageInput" @keyup.enter="actions.sendMessage" class="ra_wc_message_input"
          v-model="state.newMessageBox" :placeholder="instance.ask_question" :readonly="state.isSending"
          @click="() => { updateCursorPosition(); hideEmoji(); }" @keyup="updateCursorPosition">
        </textarea>

        <!-- Action Buttons -->
        <div class="ra_wc_message_actions">

          <div class="ra_wc_spinner-container" v-if="state.isSending">
            <div class="ra_wc_spinner"></div>
          </div>

          <!-- Toggle Emoji Picker -->
          <button type="button" class="ra_wc_icon" ref="emojiButton" @click.stop="toggleEmojiPicker" :disabled="state.isSending">
            😊
          </button> <!-- Emoji Button -->

          <button type="button" class="ra_wc_icon" @click="actions.triggerFileUpload('image')" :disabled="state.isSending">
            📷
          </button> <!-- Image -->

          <button type="button" class="ra_wc_icon" @click="actions.triggerFileUpload('file')" :disabled="state.isSending">
            📎
          </button> <!-- File -->

          <input type="file" ref="fileUp" @change="actions.handleFileUpload"  hidden
            :disabled="state.isSending" />
        </div>

      </div>

    </div>


    <div   class="ra_wc_container"    :class="[instance.bubblePosition === 'right' ? 'right' : 'left']"  v-if="state.showPopUp && instance.widget_style=='modern'">
  <!-- Header -->

      <div class="ra_wc_header ra_wc_bg">
        <div class="ra_wc_header_left">

          <div  v-if="instance.logo_avatar" class="ra_wc_minimize ra_wc-w-8 ra_wc-h-8 ra_wc-flex ra_wc-items-center ra_wc-justify-center ra_wc-bg-white ra_wc-text-gray-400 ra_wc-rounded-full">
            <img :src="instance.logo_avatar" class="ra_wc-w-full ra_wc-h-full ra_wc-object-cover ra_wc-rounded-full" />

          </div>

          <div class="right-header-text">
            <div class="ra_wc_title ra_wc_text-white">
            {{instance.welcome_message }}
            </div>
            <div class="ra_wc_subtitle ra_wc_text-white">
                {{instance.welcome_tagline }}
            </div>
          </div>
        </div>
        <div class="ra_wc_header_right">
          <span class="ra_wc_sound_toggle">

            <svg v-if="state.stopMessageSound" @click="handleSound(false)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-volume-mute-fill ra_wc_text-white" viewBox="0 0 16 16">
                  <path fill="currentColor" d="M6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06m7.137 2.096a.5.5 0 0 1 0 .708L12.207 8l1.647 1.646a.5.5 0 0 1-.708.708L11.5 8.707l-1.646 1.647a.5.5 0 0 1-.708-.708L10.793 8 9.146 6.354a.5.5 0 1 1 .708-.708L11.5 7.293l1.646-1.647a.5.5 0 0 1 .708 0"/>
            </svg>

            <svg v-else @click="handleSound(true)"  xmlns="http://www.w3.org/2000/svg" width="16" height="16"   class="bi bi-volume-up-fill ra_wc_text-white" viewBox="0 0 16 16">
              <path fill="currentColor" d="M11.536 14.01A8.47 8.47 0 0 0 14.026 8a8.47 8.47 0 0 0-2.49-6.01l-.708.707A7.48 7.48 0 0 1 13.025 8c0 2.071-.84 3.946-2.197 5.303z"/>
              <path fill="currentColor" d="M10.121 12.596A6.48 6.48 0 0 0 12.025 8a6.48 6.48 0 0 0-1.904-4.596l-.707.707A5.48 5.48 0 0 1 11.025 8a5.48 5.48 0 0 1-1.61 3.89z"/>
              <path fill="currentColor" d="M8.707 11.182A4.5 4.5 0 0 0 10.025 8a4.5 4.5 0 0 0-1.318-3.182L8 5.525A3.5 3.5 0 0 1 9.025 8 3.5 3.5 0 0 1 8 10.475zM6.717 3.55A.5.5 0 0 1 7 4v8a.5.5 0 0 1-.812.39L3.825 10.5H1.5A.5.5 0 0 1 1 10V6a.5.5 0 0 1 .5-.5h2.325l2.363-1.89a.5.5 0 0 1 .529-.06"/>
            </svg>

                
            

          <!-- <span class="ra_wc_minimize" @click="state.showPopUp = false" title="Minimize">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"  class="bi bi-dash-lg ra_wc_text-white" viewBox="0 0 16 16">
              <path fill="currentColor" fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8"/>
            </svg>
          </span> -->

        </span> 
        
        </div>
      </div>

      <!-- Chat -->
      <div class="ra_wc_chat_wrapper"  @scroll="handleScroll" v-if="state.chatStage !== 'start_conversation'" ref="chatBox">
        <div class="ra_wc_spinner-container" v-if="state.scrollLoading" style="margin:auto;display:block">
          <div class="ra_wc_spinner"></div>
        </div>
      
        <div v-for="(msg, index) in sortedMessages" :key="index" class="ra_wc_message_group">
          <div :class="['ra_wc_message', msg.direction === 'in' ? 'ra_wc_user ra_wc_bg ra_wc_text-white' : 'ra_wc_bot']">

            <div v-if="msg.message_type == 'text'">
              <p v-html="msg.message"></p>
            </div>

            <div v-else-if="msg.message_type == 'image'" class="ra_wc_message_image_thumb">
              <a :href="msg.file_path" target="_blank">
                <img :src="msg.thumbnail">
              </a>
              <p v-if="msg.message != ''" style="margin-top: 3px;">{{ msg.message }}</p>
            </div>

            <div v-else-if="msg.message_type == 'image_url'" class="ra_wc_message_image_thumb">
              <a :href="msg.file_path" target="_blank">
                <img :src="msg.file_path">
              </a>
              <p v-if="msg.message != ''" style="margin-top: 3px;">{{ msg.message }}</p>
            </div>

            <div v-else-if="msg.message_type == 'document'">
              <a :href="msg.file_path" target="_blank">{{ msg.file_name }}</a>
              <p v-if="msg.message != ''" style="margin-top: 3px;">{{ msg.message }}</p>
            </div>

            <div v-else-if="msg.message_type == 'audio'">
              <audio controls class="ra_wc_small-audio-player">
                <source :src="msg.file_path" :type="msg.file_type">
                Your browser does not support the audio element.
              </audio>
              <p v-if="msg.message != ''" style="margin-top: 3px;">{{ msg.message }}</p>
            </div>

            <div v-else-if="msg.message_type == 'video'">
              <video width="150" height="150" controls>
                <source :src="msg.file_path" :type="msg.file_type">
                Your browser does not support the video tag.
              </video>
              <p v-if="msg.message != ''" style="margin-top: 3px;">{{ msg.message }}</p>
            </div>

            <div v-else-if="msg.message_type == 'other'">
              <a :href="msg.file_path" target="_blank">{{ msg.file_name }}</a>
              <p v-if="msg.message != ''" style="margin-top: 3px;">{{ msg.message }}</p>
            </div>

          </div>

        
          <div :class="[ msg.direction === 'in' ? 'ra_wc_timestamp_user' : 'ra_wc_timestamp']"  v-if="msg.updatedAt">
            <span v-if="msg.direction == 'out' && msg.sender && msg.sender!=='boot'" > {{msg.sender}} &nbsp;&nbsp;</span>  {{ formatTime(msg.updatedAt) }}
          </div>

        </div>


        <div class="ra_wc_message ra_wc_bot"   v-if="state.is_typeing">
          <div class="ra_wc_chat-typing">
              <span class="ra_wc_dot"></span>
              <span class="ra_wc_dot"></span>
              <span class="ra_wc_dot"></span>
            </div>
        </div>
        


        
      </div>

       

      <!-- Input -->
      <div v-if="state.emojiPickerVisible" ref="emojiPickerRef"  @click.stop class="ra_wc_emoji-popup">
        <EmojiPicker @select="addEmoji" :disable-skin-tones="true" />
      </div>
      <div class="ra_wc_input_area">
        
        <div v-if="state.chatStage === 'start_conversation'" class="ra_wc_input_box" style="background:#f9f9f9;flex-direction: row" >
          <div class="ra_wc_wel_chat-content">
              <p v-if="instance.welcome_launcher_title != ''"><b>{{ instance.welcome_launcher_title }}</b></p>
              <p v-if="instance.launcher_reply_time != ''">{{ instance.launcher_reply_time }}</p>
              <a style="text-decoration:none;" href="javascript:void(0);" @click="actions.startCoversation"> <span
                  v-if="instance.launcher_reply_time != ''">{{ instance.launcher_link_text }}</span> <span v-else>Start
                  Conversation</span> →</a>
          </div>
          <div v-if="instance.lanucher_avatar != ''">
             <img class="ra_wc_wel_chat-avatar" style="margin-left: 40px; margin-top: 14px;" :src="instance.lanucher_avatar" />
          </div>
        </div>

        <div v-else-if="state.chatStage === 'info_gather'"  class="ra_wc_input_box" style="background-color: white;">

            <div v-if="instance.prechat_name == '1' && state.infoAtive == 'name'" class="ra_wc_width">
              <label class="ra_wc_info-label">{{ instance.prechat_name_label }}</label>
              <div class="ra_wc_info-input-wrapper">
                <input  @input="state.infoError = ''" @keyup.enter="actions.validateInfo('name')" type="text"
                  class="ra_wc_info-input" v-model="state.userName" :placeholder="instance.prechat_name_placeholder" >
                <button :style="{ backgroundColor: instance.bubbleColor }" @click.prevent="actions.validateInfo('name')"
                  class="ra_wc_info-button">&gt;</button>
              </div>
            </div>

            <div v-if="instance.prechat_email && state.infoAtive == 'email'" class="ra_wc_width">
              <label class="ra_wc_info-label">
                {{ instance.prechat_email_label == '' ? "Please enter email" : instance.prechat_email_label }}
              </label>
              <div class="ra_wc_info-input-wrapper">
                <input @input="state.infoError = ''" @keyup.enter="actions.validateInfo('email')"
                  :placeholder="instance.prechat_email_placeholder" v-model="state.userEmail" type="email"
                  class="ra_wc_info-input" autofocus>
                <button @click.prevent="actions.validateInfo('email')" :style="{ backgroundColor: instance.bubbleColor }"
                  class="ra_wc_info-button">&gt;</button>
              </div>
              <div v-if="state.infoError" class="ra_wc_error-message">
                <strong>{{ state.infoError }}</strong>
              </div>
            </div>

            <div v-if="instance.prechat_whatsapp == '1' && state.infoAtive == 'whatsapp'" class="ra_wc_width phone-container">
              <label class="ra_wc_info-label">{{ instance.prechat_whatsapp_label }}</label>
              <div class="ra_wc_info-input-wrapperP " >
                <input
                        ref="whatsappInput"
                        @input="state.infoError = ''"
                        @keyup.enter="actions.validateInfo('whatsapp')"
                        v-model="state.userWhatsapp"
                        type="tel"
                        class="ra_wc_info-input"
                        autofocus
                      >
                    <button :style="{ backgroundColor: instance.bubbleColor }" @click.prevent="actions.validateInfo('whatsapp')"
                  class="ra_wc_info-button">&gt;</button>
              </div>
              <div v-if="state.infoError" class="ra_wc_error-message">
                <strong>{{ state.infoError }}</strong>
              </div>
            </div>

            <div v-if="instance.prechat_phone == '1' && state.infoAtive == 'phone'" class="ra_wc_width phone-container">
              <label class="ra_wc_info-label">{{ instance.prechat_phone_label }}</label>
              <div class="ra_wc_info-input-wrapperP" >
                <input ref="phoneInput"  @input="state.infoError = ''" @keyup.enter="actions.validateInfo('phone')" v-model="state.userPhone"
                  type="text" :placeholder="instance.prechat_phone_placeholder" class="ra_wc_info-input" autofocus>
                <button :style="{ backgroundColor: instance.bubbleColor }" @click.prevent="actions.validateInfo('phone')"
                  class="ra_wc_info-button">&gt;</button>
              </div>
              <div v-if="state.infoError" class="ra_wc_error-message">
                <strong>{{ state.infoError }}</strong>
              </div>
            </div>
        </div>

        <div v-else-if="state.chatStage === 'send_message'" class="ra_wc_input_box"  :style="{ minHeight: state.uploadedFiles.length ? '80px' : '' }"
        @dragover.prevent="actions.handleDrop" @drop="actions.handleDrop" @paste="actions.handlePaste">
          
          
        <div class="ra-wc-image-preview" v-if="state.uploadedFiles.length">
          <div v-for="(file, index) in state.uploadedFiles" :key="index" class="ra-wc-file-preview">
            <img v-if="file.type.startsWith('image/')" :src="file.preview" class="ra-wc-preview-img" />
            <span v-else class="ra-wc-file-name"><small>{{ actions.getShortFileName(file.name) }}</small></span>
            <button v-if="!state.isSending" class="ra-wc-remove-preview" @click="actions.removeFile(index)">✖</button>
          </div>
        </div>
          
          <textarea class="ra_wc_textarea" autofocus ref="messageInput" @keyup.enter="actions.sendMessage"
           v-model="state.newMessageBox"
           :readonly="state.isSending"
          @click="() => { updateCursorPosition(); hideEmoji(); }" 
          @keyup="() => { updateCursorPosition(); userTyping(); }"
          
           :placeholder="instance.ask_question"></textarea>

          <div class="ra_wc_input_footer">
            <span class="ra_wc_icon" @click.stop="toggleEmojiPicker"  :disabled="state.isSending">😊</span>
            <span class="ra_wc_icon" @click="actions.triggerFileUpload('image')" :disabled="state.isSending">📷</span>
            <span class="ra_wc_icon" @click="actions.triggerFileUpload('file')" :disabled="state.isSending">📎</span>
            <button class="ra_wc_send_button" :disabled="state.isSending" @click="actions.sendMessage">
            <div class="ra_wc_spinner-container" v-if="state.isSending">
              <div class="ra_wc_spinner"></div>
            </div>
              <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send-fill" viewBox="0 0 16 16">
                <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471z"/>
              </svg>
            </button>

            <input type="file" ref="fileUp" @change="actions.handleFileUpload"  hidden
            :disabled="state.isSending" />

          </div>
        </div>
        

        
        

        
      </div>

      <!-- Footer -->
      <div class="ra_wc_footer ra_wc_bg ra_wc_text-white" v-html="instance.footer_text">
        
      </div>
    </div>

    <div v-if="state.showPopUp"
      class="bubble pointer ra_wc_fixed ra_wc_bottom-6 ra_wc_text-white ra_wc_w-12 ra_wc_h-12 ra_wc_rounded-full ra_wc_flex ra_wc_items-center ra_wc_justify-center"
      :class="{ 'ra_wc_right-6 ra_wc_mr-2': instance.bubblePosition === 'right', 'ra_wc_left-6 ra_wc_ml-2': instance.bubblePosition === 'left' }"
      :style="{ backgroundColor: instance.bubbleColor }" @click="state.showPopUp = false">
      &#10005;
    </div>


    <div v-else class="bubble" :class="[
      instance.bubblePosition === 'right' ? 'ra_wc_right-6 right pointer' : 'left pointer',
      instance.bubbleType == 'retracted' ? 'ra_wc_h_r-12 ra_wc_w_r-12 ra_wc_rounded-full ra_wc_flex ra_wc_items-center ra_wc_justify-center ra_wc_fixed ra_wc_bottom-6' : 'ra_wc_bubble'
    ]" :style="{ backgroundColor: instance.bubbleColor }" @click="() => { state.showPopUp = true; scrollToBottom();initMask(); }">

      <img :src="previewIcon"  :class="{
                          'ra_wc_w-8 ra_wc_h-8': instance.bubbleType === 'expanded',
                          'ra_wc_w-r-8 ra_wc_h-r-8': instance.bubbleType === 'retracted',
                        }">

      <span v-if="instance.bubbleType === 'expanded'" class="ra_wc_text-white" style="margin-right: 10px;">
        {{ instance.bubbleText }}
      </span>
      <span class="chat-badge" v-if="state.messageCounter > 0" >{{state.messageCounter}}</span>
    </div>
  </div>
</template>


<script setup>
import { computed, onMounted, reactive, defineProps, ref, nextTick,watch,onBeforeUnmount} from 'vue';
import { io } from "socket.io-client";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { useWidgetStore } from '@/stores/widget';
import intlTelInput from 'intl-tel-input'
import whatsIn from 'intl-tel-input'
import { PhoneNumberUtil, PhoneNumberFormat, PhoneNumberType } from 'google-libphonenumber';
import 'intl-tel-input/build/css/intlTelInput.css';

dayjs.extend(utc)
dayjs.extend(timezone)



const store = useWidgetStore();

import EmojiPicker from "vue3-emoji-picker";


const chatBox = ref(null);
const fileUp = ref(null);
const cursorPosition = ref(0);
const messageInput = ref(null);
const notificationSound = new Audio("https://sfmediastrg.s3.us-east-1.amazonaws.com/assets/system_assets/chatbot-recieved-notification.mp3");
const emojiPicker = ref(null);
const emojiButton = ref(null);
// used for to show chat bubble
const isAppReady = computed(() => {
  return !state.is_loading && state.is_data;
});

const phoneInput    = ref(null);
const whatsappInput = ref(null);
let phoneiti=null;
let whatsappIti=null;




// used for messages sorting
const sortedMessages = computed(() => {
  return [...state.messages].sort((a, b) => {
    return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(); // ascending
  });
});



// get slug from frontend 
const props = defineProps({
  slug: {
    type: String,
    default: null
  },
});

// used for default variables
const state = reactive({
  socket:  '',
  chatStage : localStorage.getItem('ra_wc_chatStage') || 'start_conversation',
  is_typeing :false,
  typingTimout : 0,
  userName:  "",
  userEmail: "",
  userPhone: "",
  userWhatsapp: "",
  userId: localStorage.getItem("chatUserId") || '',
  userInfoArray: [],
  infoAtive: '',
  isStartCover: localStorage.getItem("isStartCover") || "",
  showPopUp: false,
  is_loading: true,
  position: "right_bottom",
  is_data: false,
  infoError: "",
  icons: [
    {
      type: 1,
      image:
        'https://sfmediastrg.s3.us-east-1.amazonaws.com/assets/system_assets/webchat1.svg',
    },
    {
      type: 2,
      image:
        'https://sfmediastrg.s3.us-east-1.amazonaws.com/assets/system_assets/webchat2.svg',
    },
    {
      type: 3,
      image:
        'https://sfmediastrg.s3.us-east-1.amazonaws.com/assets/system_assets/webchat3.svg',
    }
  ],
  newMessageBox: '',
  messages: [],
  VUE_APP_RA_API_URL: "",
  uploadedFiles: [],
  isSending: false,
  emojiPickerVisible: false,
  infoComplete:false,
  messageCounter : 0,
  originalTitle : document.title,
  blinkInterval : null,
  isBlinking    : false,
  stopMessageSound : localStorage.getItem('stopMessageSound') || false,
  isActiveTab      : true,
  last_message     : '',
  scrollLoading    : false,
  loadNewMessages  : true,
  gatewayConfirmation : localStorage.getItem('stopMessageSound') || false,
  ra_wc_confirmed : localStorage.getItem('ra_wc_confirmed') || false,
  VUE_WIDGET_URL : '',

  
});



function initMask()
{
  if(state.infoAtive=="phone" && state.chatStage=="info_gather")
    {
      setTimeout(function(){
        initPhone();
        },1000);
     
    }

    if(state.infoAtive=="whatsapp" && state.chatStage=="info_gather")
    {
      setTimeout(function(){
          initwhatsApp();
        },1000);
    }
}



// Emoji handling code

const toggleEmojiPicker = () => {
  state.emojiPickerVisible = !state.emojiPickerVisible;
};

const hideEmoji = () => {
  state.emojiPickerVisible = false;

};

const addEmoji = (emoji) => {
  const pos = cursorPosition.value;
  if (pos === undefined) {
    state.newMessageBox += emoji.i;
  } else {
    // Split text at cursor position
    const beforeText = state.newMessageBox.slice(0, pos);
    const afterText = state.newMessageBox.slice(pos);
    state.newMessageBox = beforeText + emoji.i + afterText;

    // Move cursor after emoji
    nextTick(() => {
      messageInput.value.selectionStart = pos + emoji.i.length;
      messageInput.value.selectionEnd = pos + emoji.i.length;
      messageInput.value.focus();
    });
  }
};


const handleClickOutside = (event) => {
  const picker = emojiPicker.value
  const button = emojiButton.value

  const clickedInsidePicker = picker?.contains(event.target)
  const clickedEmojiButton = button?.contains(event.target)

  if (!clickedInsidePicker && !clickedEmojiButton) {
    hideEmoji();
  }

};

const updateCursorPosition = () => {
  cursorPosition.value = messageInput.value.selectionStart;
};


//////////////////////////////////////////

// used for scrolling and pagination and handel sound
const handleSound = (value) => {
 
  state.stopMessageSound = value;
  localStorage.setItem('stopMessageSound',value);

};


const scrollToBottom = () => {
  nextTick(() => {
    if (chatBox.value) {
      chatBox.value.scrollTop = chatBox.value.scrollHeight;
      messageInput.value.focus();

    }
  });
  
};


const handleScroll = async () => {
  const el = chatBox.value;

  if (el.scrollHeight - el.scrollTop <= el.clientHeight + 1) {
    state.messageCounter = 0;
  }

  if (el.scrollTop === 0 && !state.scrollLoading && state.loadNewMessages && state.userId) {
    state.scrollLoading = true;

    state.socket.emit("getUserPreviousMessages", JSON.stringify({
      user_id: state.userId,
      skip: state.messages.length
    }), async (response) => {
      state.scrollLoading = false;

      if (response.messages.length === 0) {
        state.loadNewMessages = false;
      } else {
        const previousHeight = el.scrollHeight;

        response.messages.reverse().forEach((message) => {
          state.messages.unshift(message); // Prepend
        });

        await nextTick();

        const newHeight = el.scrollHeight;
        el.scrollTop = newHeight - previousHeight; // Preserve position
      }
    });
  }
};


const userTyping = () => {
  if(state.userId)
  {
    state.socket.emit('CHAT_USER_TYPING',{user_id:state.userId,message:state.newMessageBox})    
  }
};

/////////////////////////////////////////////////////



/// Instance default config

const instance = reactive({

  bubbleType: "expanded",
  bubbleText: "Chat with us",
  bubbleIcon: 1,
  bubblePosition: "right",
  bubbleColor: "#3781b8",
  color: "#3781b8",
  widget_style : "modren",
  footer_text  : "",
  welcome_message: "Welcome",
  welcome_tagline: "We are here to help you",
  welcome_launcher_title: "We are online",
  launcher_reply_time: "Typically replies immediately",
  launcher_link_text: "Start Conversation ",

  prechat_option: "default",
  prechat_name: 0,
  prechat_name_label: "Please enter name",
  prechat_name_placeholder: "",

  prechat_email: 0,
  prechat_email_label: "Please enter email",
  prechat_email_placeholder: "",

  prechat_whatsapp: 0,
  prechat_whatsapp_label: "Please enter whatsapp",
  prechat_whatsapp_placeholder: "",

  prechat_phone: 0,
  prechat_phone_label: "Please enter phone number",
  prechat_phone_placeholder: "",


  prechat_message: "",
  lanucher_avatar: '',
  logo_avatar: '',

  ask_question : "Ask a question"
});

const actions = reactive({

  sendMessage: async () => {

    if (state.newMessageBox.trim().length > 0 && state.uploadedFiles.length == 0) {
     
      setChatExpiry()
      
      state.isSending = true;

      state.newMessageBox = state.newMessageBox.trim();
      const tempId = Date.now();

      const messageObj = { sender: state.userName, type: "text", message: state.newMessageBox, tempId: tempId, status: '0', direction: "in", time: '', widgetId: props.slug,ra_wc_confirmed:state.ra_wc_confirmed };

      if (state.userId != '') {
        messageObj.isRegisted = true;
        messageObj.userId = state.userId;
      }
      else {
        let u_tempId = state.socket.id + Date.now().toString();
        localStorage.setItem('u_temp_id', u_tempId);

        messageObj.isRegisted = false;
        messageObj.username = state.userName;
        messageObj.email = state.userEmail;
        messageObj.whatsapp = state.userWhatsapp;
        messageObj.phone = state.userPhone;
        messageObj.userTempId = u_tempId;
      }


      state.socket.emit("sendMessage", JSON.stringify(messageObj), (response) => {
      
        if(response.message)
        {
          state.messages.push(response.message);
          scrollToBottom();
          state.newMessageBox = '';
          state.isSending = false;
          state.userId = response.message.user_id;
          localStorage.setItem("chatUserId", state.userId);
        }
        else
        {
          state.newMessageBox = '';
          state.isSending = false;
          alert ("something went wrong, Try later")
        }
        
      });


    }
    else if (state.newMessageBox.trim().length > 0 && state.uploadedFiles.length > 0) {
      state.isSending = true;
      setChatExpiry();
   
      if (state.userId != '') {

        // Will send sepearate message
        // const messageObj = {
        //   sender: state.userName, type: "text", message: state.newMessageBox, tempId: '', status: '0', direction: "in", time: '', widgetId: props.slug, isRegisted: true,
        //   userId: state.userId,
        // };

        // state.socket.emit("sendMessage", JSON.stringify(messageObj), (response) => {
        //   state.messages.push(response.message);
        //   scrollToBottom();
        //   state.newMessageBox = '';
        // });

        for (let i = 0; i < state.uploadedFiles.length; i++) {

          const fileToSend = state.uploadedFiles[i];
           await actions.uploadFile(fileToSend, state.userId);

        }
      }
      else {

        let u_tempId = state.socket.id + Date.now().toString();
        localStorage.setItem('u_temp_id', u_tempId);

        const messageObj = {
          widgetId: props.slug,
          username: state.userName,
          email: state.userEmail,
          whatsapp: state.userWhatsapp,
          phone: state.userPhone,
          userTempId: u_tempId,
        };

        state.socket.emit("sendUserInfo", JSON.stringify(messageObj), async (response) => {

          state.userId = response.user_id;
          localStorage.setItem("chatUserId", state.userId);

          // const messageObj1 = {
          //   sender: state.userName, type: "text", message: state.newMessageBox, tempId: '', status: '0', direction: "in", time: '', widgetId: props.slug, isRegisted: true,
          //   userId: state.userId,
          // };

          // state.socket.emit("sendMessage", JSON.stringify(messageObj1), (response) => {
          //   state.messages.push(response.message);
          //   scrollToBottom();
          //   state.newMessageBox = '';
          // });

          for (let i = 0; i < state.uploadedFiles.length; i++) {

            const fileToSend = state.uploadedFiles[i];
             await actions.uploadFile(fileToSend, state.userId);

          }

        });
      }

    }
    else if (state.newMessageBox.trim().length == 0 && state.uploadedFiles.length > 0) {
      state.isSending = true;
      setChatExpiry();
      if (state.userId != '') {
        for (let i = 0; i < state.uploadedFiles.length; i++) {

          const fileToSend = state.uploadedFiles[i];
           await actions.uploadFile(fileToSend, state.userId, i);

        }
      }
      else {
        let u_tempId = state.socket.id + Date.now().toString();
        localStorage.setItem('u_temp_id', u_tempId);

        const messageObj = {
          widgetId: props.slug,
          username: state.userName,
          email: state.userEmail,
          whatsapp: state.userWhatsapp,
          phone: state.userPhone,
          userTempId: u_tempId,
        };

        state.socket.emit("sendUserInfo", JSON.stringify(messageObj), async (response) => {

          state.userId = response.user_id;
          localStorage.setItem("chatUserId", response.user_id);

          for (let i = 0; i < state.uploadedFiles.length; i++) {

            const fileToSend = state.uploadedFiles[i];
             await actions.uploadFile(fileToSend, state.userId);

          }

        });
      }

    }
    else {
      
      alert("Please enter message");
      return;
    }

  },
  uploadFile: async (file, userId = '', index) => {
    const formData = new FormData();
    formData.append("media", file.file);
    formData.append("userId", userId);
    formData.append("message", state.newMessageBox);
    try {
      const response = await fetch(state.VUE_APP_RA_API_URL + "/send_media_message", {
        method: "POST",
        body: formData
      });

      const result = await response.json();
      state.messages.push(result.message);
      state.uploadedFiles.splice(index, 1);
      scrollToBottom();
      if (state.uploadedFiles.length == 0) {
        state.isSending = false;
        state.newMessageBox = '';
      }
      return true;
    } catch (error) {
      console.error("Upload failed:", error);
      return null;
    }
  },
  startCoversation: () => {

    if (instance.prechat_option == "default" && (instance.prechat_name == "1" || instance.prechat_email == "1" || instance.prechat_whatsapp == "1" || instance.prechat_phone)) {

      if(instance.prechat_message != '')
      {
        state.messages.push({message_type:"text",direction:"out",message:instance.prechat_message,updatedAt:dayjs().utc(),'sender':"boot"})
      }
      state.chatStage="info_gather"
      localStorage.setItem("ra_wc_chatStage","info_gather");

      initMask();
      
    }
    else {

      state.chatStage="send_message"
      localStorage.setItem("ra_wc_chatStage","send_message");

    }
  },
  validateInfo: (type) => {
    const fieldMappings = {
      name: { value: state.userName.trim(), message: "Please enter a valid name!" },
      email: { value: state.userEmail.trim(), message: "Please enter a valid email!", regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/ },
      phone: { value: state.userPhone.trim(), message: "Please enter a valid phone!", regex: /^\d{10,15}$/ },
      whatsapp: { value: state.userWhatsapp.trim(), message: "Please enter a valid WhatsApp number!", regex: /^\d{10,15}$/ }
    };

    const field = fieldMappings[type];

    if (!field) {
      console.error("Invalid field type!");
      return;
    }

    if (field.value.trim().length === 0) {
      state.infoError = field.message;
      return;
    }

    if (field.regex && !field.regex.test(field.value)) {
      state.infoError = field.message;
      return;
    }
    else {

      let message = '';
      if (type === "name") {
        message = `<b>${instance.prechat_name_label}:</b> <br> ${field.value}`;
      }
      else if(type==="email")
      {
        message = `<b>${instance.prechat_email_label}:</b> <br> ${field.value}`;
      }
      else if(type==="whatsapp")
      {
        
        const countryData = whatsappIti.getSelectedCountryData();
        state.userWhatsapp=countryData.dialCode+state.userWhatsapp;
        message = `<b>${instance.prechat_whatsapp_label}:</b> <br> ${countryData.dialCode}${field.value}`;
      }
      else if(type==="phone")
      {
        const countryData = phoneiti.getSelectedCountryData();
        state.userPhone=countryData.dialCode+state.userPhone;
        message = `<b>${instance.prechat_phone_label}:</b> <br> ${countryData.dialCode}${field.value}`;
      }
      state.messages.push({message_type:"text",direction:"in",message:message,updatedAt:dayjs().utc(),createdAt:dayjs().utc()})

      state.userInfoArray.push({
        message_type: "text",
				message: message,
				status: 0,
				temp_id: '',
				direction: "in",
				sender: 'user'
        });

      scrollToBottom();
    }


    actions.checkNextInfoStep(type);
  },

  checkNextInfoStep: (current) => {
   
    const steps = [];
    if (instance.prechat_name === '1') steps.push('name');
    if (instance.prechat_email === '1') steps.push('email');
    if (instance.prechat_whatsapp === '1') steps.push('whatsapp');
    if (instance.prechat_phone === '1') steps.push('phone');

    if (steps.length === 0) {
   
      return;
    }


    if (!current) {
      
      state.infoAtive = steps[0];
      if(steps[0]=="phone" && state.showPopUp)
      {
        initPhone(); 
      }

      if(steps[0]=="whatsapp" && state.showPopUp)
      {
        setTimeout(function(){
          initwhatsApp();
        },1000);
      }
      return;
    }

    const currentIndex = steps.indexOf(current);
    
    if (currentIndex === -1 || currentIndex === steps.length - 1) {

      state.chatStage="send_message"
      localStorage.setItem("ra_wc_chatStage","send_message");

        let u_tempId = state.socket.id + Date.now().toString();
        localStorage.setItem('u_temp_id', u_tempId);

        const messageObj = {
          widgetId: props.slug,
          username: state.userName,
          email: state.userEmail,
          whatsapp: state.userWhatsapp,
          phone: state.userPhone,
          userTempId: u_tempId,
          startInfo: state.userInfoArray,
        };

        state.socket.emit("sendUserInfo", JSON.stringify(messageObj), async (response) => {
         
          state.userId = response.user_id;
          localStorage.setItem("chatUserId", state.userId);
          setChatExpiry()
        });
    } else {


      state.infoAtive = steps[currentIndex + 1];
      if(state.infoAtive=="phone" && state.showPopUp)
      {
        setTimeout(function(){
        initPhone();
        },1000); 
      }

      if(state.infoAtive=="whatsapp" && state.showPopUp)
      {
        setTimeout(function(){
          initwhatsApp();
        },1000);
      }
    }
  },
  triggerFileUpload: (type) => {

       // Set accept attribute based on type
       if (type === 'image') {
        fileUp.value.setAttribute('accept', 'image/*')
      } else {
        fileUp.value.removeAttribute('accept')
      }

    fileUp.value.value = null
    fileUp.value.click();
  },

  handleFileUpload: (event) => {
    const files = event.target.files;
    actions.processFiles(files);
  },

  handleDrop: (event) => {

    event.preventDefault();
    const files = event.dataTransfer.files;
    actions.processFiles(files);
  },

  handlePaste: (event) => {
    const items = (event.clipboardData || event.originalEvent.clipboardData).items;
    for (const item of items) {
      if (item.kind === "file") {
        const file = item.getAsFile();
        actions.processFiles([file]);
      }
    }
  },

  processFiles: (files) => {
  if (!state.isSending) {
    for (const file of files) {
      if (!file) continue;

      // File size limit check: 20MB = 20 * 1024 * 1024 bytes
      const maxSize = 20 * 1024 * 1024;
      if (file.size > maxSize) {
        alert(`File "${file.name}" is too large. Max allowed size is 20MB.`);
        continue;
      }

      const reader = new FileReader();
      reader.onload = () => {

        state.uploadedFiles = []; // only one file allowed

        state.uploadedFiles.push({
          name: file.name,
          type: file.type,
          preview: reader.result,
          file: file,
        });
      };
      reader.readAsDataURL(file);
    }

    messageInput.value?.focus()
  }
},


  removeFile: (index) => {
    state.uploadedFiles.splice(index, 1);
    fileUp.value.value = null
  },

  getShortFileName: (file) => {
    if (!file) return "";

    const fileName = file;
    const fileExtension = fileName.split(".").pop(); // Get the extension
    const nameWithoutExt = fileName.replace(/\.[^/.]+$/, ""); // Remove extension

    // Take the first 4 characters and add ".." before the extension
    const shortName = nameWithoutExt.substring(0, 4) + ".." + fileExtension;

    console.log(shortName);

    return shortName;
  }


});

const formatTime = (utcTime) => {
  const messageTime = dayjs.utc(utcTime).local();
  const now = dayjs();

  if (messageTime.isSame(now, 'day')) {
    return messageTime.format('hh:mm A'); // Only time
  } else {
    return messageTime.format('hh:mm A · DD/MM/YY'); // Time + date
  }
}




const previewIcon = computed(() => {
  let uicon = parseInt(instance.bubbleIcon);
  const found = state.icons.find((icon) => icon.type === uicon);
  return found ? found.image : null;
});

const reinitiateChat = () => { 

      localStorage.clear();
      state.chatStage="start_conversation"
      localStorage.setItem("ra_wc_chatStage","start_conversation");

      localStorage.setItem("ra-chatbot-slug",props.slug);
      state.messages=[];
      state.newMessageBox='';
      state.uploadedFiles=[];
      state.userName='';
      state.userEmail='';
      state.userPhone='';
      state.userWhatsapp='';
      state.userId='';
      state.emojiPickerVisible=false;
      state.userInfoArray=[];
      state.ra_wc_confirmed=false;

      if (instance.prechat_option === "default") 
      {
          actions.checkNextInfoStep('');
      }
      

}; 

const startTitleBlinking = () => {
  if (state.isBlinking) return
  state.isBlinking = true
  let message="🔔 New Message!";
  let show = true
  state.blinkInterval = setInterval(() => {
    document.title = show ? message : state.originalTitle
    show = !show
  }, 1000)
}


watch(
  () => state.messageCounter,
  (newVal) => {
    if (newVal > 0) {
      startTitleBlinking()
    } else {
      if (state.blinkInterval) {
        clearInterval(state.blinkInterval)
        document.title = state.originalTitle
        state.blinkInterval = null
        state.isBlinking = false
      }
    }
  }
);

function checkTypeingTimout() {
  setInterval(function(){

    if(state.typingTimout > 0)
    {
      state.typingTimout= state.typingTimout - 1;
      if(state.typingTimout==0)
      {
        state.is_typeing=false;
      }
    }

  },1000);
}

/////////////////////////////////////////////////////////////



onMounted(() => {

  ///// connection socket io with our webchat serice
  state.VUE_APP_RA_API_URL = process.env.VUE_APP_RA_API_URL;
  state.VUE_WIDGET_URL=process.env.VUE_WIDGET_URL;

  state.socket = io(state.VUE_APP_RA_API_URL, {
    transports: ["websocket", "polling"],
  });


 
  

  //////////////////////////////////////////////////////////////////

  
  if(localStorage.getItem("ra-chatbot-slug") && props.slug!=localStorage.getItem("ra-chatbot-slug"))
  {
    reinitiateChat ();
  }
  else
  {
    localStorage.setItem("ra-chatbot-slug",props.slug)
  }
 
  fetchData();
  checkChatExpiry();


  // socket event code
  if (state.socket) {

    checkTypeingTimout();

    state.socket.on("WC_NEW_MESSAGE", (data) => {

      console.log("New");

      if (state.userId === data.user_id) {
        state.is_typeing=false;
        state.typingTimout=0;

        state.messages.push(data);
        if(state.showPopUp)
        {
          scrollToBottom();
          if(!state.isActiveTab)
          {
            state.messageCounter+=1;
          }
        }
        else
        {
          state.messageCounter+=1;
        }

        if(!state.stopMessageSound)
        {
          notificationSound.play().catch(err => {
           console.warn("Unable to play sound:", err);
          });
        }
       
      }

    });

    state.socket.on("PROFILE_CALL_BACK", (data) => {
      console.log(data);
      if (localStorage.getItem('u_temp_id') === data.tempId) {
        state.userId = data.user_id;

        localStorage.removeItem('u_temp_id');

        localStorage.setItem('ra_wc_confirmed',true);
        state.ra_wc_confirmed=true;

        if(data.already_exist)
        {
          state.messages=[];

          data.messages.forEach((message) => {
            state.messages.push(message);
            scrollToBottom();
          });

        }
      }
    });

    state.socket.on("DESTROY_CHAT", (data) => {
      if (state.userId == data.userID) {
        reinitiateChat ();
      }
    });

    state.socket.on("DESTROY_INSTANCE", (data) => {
      if (props.slug == data.instance_token) {
           localStorage.clear();
           state.is_loading = true;
           state.is_data = false;

      }
    });

    state.socket.on("SEND_AGENT_TYPING_TO_USER", (data) => {
  
     
    if (state.userId === data.user_id) {

      state.is_typeing=true;
      state.typingTimout=2;
      scrollToBottom();
        
     }
    });

  }


  document.addEventListener('click', handleClickOutside);

 

});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});

////////////////some default functions 
async function httpGetAsync(theUrl, callback) {
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState == 4 && xmlHttp.status == 200 && xmlHttp.responseText !== '') {
      callback(JSON.parse(xmlHttp.responseText));
    }
  }
  xmlHttp.open("GET", theUrl, true); // true for asynchronous 
  xmlHttp.send(null);
}


function fetchData() {

  if (typeof props.slug === "undefined" || props.slug === null || props.slug === "") {
    console.error('Some Missing slug parameter');
    return false;
  }


  const widget_slug = props.slug;

  if (typeof widget_slug !== "undefined" && widget_slug !== "") {

    let api_url = state.VUE_APP_RA_API_URL;

    const http_url = api_url + "/api/get_widget?slug=" + widget_slug + "&chatID=" + state.userId;
    httpGetAsync(http_url, function (response) {

      if (response.data) {

      

        store.setWidgetType(response.data.widget_style);

        Object.assign(instance, response.data);
        setVariables(response.data);
        setTimeout(() => {
          state.is_data = true;
        }, 1200);

        if (instance.prechat_option === "default" &&
          (instance.prechat_name === "1" ||
            instance.prechat_email === "1" ||
            instance.prechat_phone === "1" ||
            instance.prechat_whatsapp === "1")
        ) {

          if (state.chatStage!=="send_message") {

            actions.checkNextInfoStep('');
          }

          if(state.chatStage==="info_gather" && instance.prechat_message != '')
          {
    
             state.messages.push({message_type:"text",direction:"out",message:instance.prechat_message,updatedAt:dayjs().utc(),'sender':"boot"})
   
          }

        }
      }
      else {

        state.chatStage="send_message"
        localStorage.setItem("ra_wc_chatStage","send_message");

      }
      state.is_loading = false;

      if (state.userId && response.previousMessages) {

       

        response.previousMessages.forEach((message) => {
          state.messages.push(message);
          scrollToBottom();
        });

        
      }
    });

  }
}

function setVariables(response) {


  document.documentElement.style.setProperty(
    "--raw-bg",
    response.bubbleColor
  );

  document.documentElement.style.setProperty(
    "--ra-text-color",
    response.color
  );

}

function setChatExpiry() {
  const fifteenDaysLater = Date.now() + (15 * 24 * 60 * 60 * 1000); 
  localStorage.setItem('chat_expiry', fifteenDaysLater);
}





function checkChatExpiry() {
  const expiry = localStorage.getItem('chat_expiry');
  if (expiry)
  { 
    if(Date.now() > Number(expiry))
    {
      reinitiateChat ();
    }
  }
}


document.addEventListener("visibilitychange", () => {
  if (document.hidden) {
    state.isActiveTab=false;
  } else {
    state.isActiveTab=true;
    if(state.showPopUp && state.messageCounter > 0)
    {
      state.messageCounter=0;
    }
  }
})



function initPhone() {
  phoneiti = intlTelInput(phoneInput.value, {
    autoPlaceholder: "polite",
    initialCountry: 'us',
    separateDialCode: false,
    // no dropdownContainer here
  });

  if(phoneInput.value)
  {
    phoneInput.value.addEventListener('countrychange', phoneupdatePlaceholder);
  }

  setTimeout(() => {
    phoneupdatePlaceholder()
  }, 500);
}

function initwhatsApp() {
  console.log('ssss')
  whatsappIti = whatsIn(whatsappInput.value, {
    autoPlaceholder: "polite",
    initialCountry: 'us',
    separateDialCode: false,
    // no dropdownContainer here
  });

  if(whatsappInput.value)
  {
    whatsappInput.value.addEventListener('countrychange', whatsappupdatePlaceholder);
  }
  setTimeout(() => {

    whatsappupdatePlaceholder();
  }, 500);
}

function phoneupdatePlaceholder() {
    try {
      const phoneUtil = PhoneNumberUtil.getInstance();
      const countryData = phoneiti.getSelectedCountryData();
      const iso2 = countryData.iso2.toUpperCase(); // e.g., US

      const exampleNumber = phoneUtil.getExampleNumberForType(
        iso2,
        PhoneNumberType.MOBILE
      );

      const formatted = phoneUtil.format(
        exampleNumber,
        PhoneNumberFormat.NATIONAL
      );

      phoneInput.value.placeholder = formatted;
      console.log('Updated Placeholder:', formatted);
    } catch (error) {
      console.warn('No example number found for this country');
      phoneInput.value.placeholder = 'Enter phone number';
    }
  }

  function whatsappupdatePlaceholder() {
    try {
      const phoneUtil = PhoneNumberUtil.getInstance();
      const countryData = whatsappIti.getSelectedCountryData();
      const iso2 = countryData.iso2.toUpperCase(); // e.g., US

      const exampleNumber = phoneUtil.getExampleNumberForType(
        iso2,
        PhoneNumberType.MOBILE
      );

      const formatted = phoneUtil.format(
        exampleNumber,
        PhoneNumberFormat.NATIONAL
      );

      whatsappInput.value.placeholder = formatted;
      console.log('Updated Placeholder:', formatted);
    } catch (error) {
      console.warn('No example number found for this country');
      whatsappInput.value.placeholder = 'Enter phone number';
    }
  }

//////////////////////////////////////////////////////////////////////////////////

</script>
<style scoped>
:root {
  --raw-bg: #3D46CD;
  --ra-text-color: #ffffff;
  --ra-widget-type: '';
}

</style>